<!-- DEV NOTE: Consider merging BaseFormElement into/with BaseShowElement -->
<template>
  <div
    :class="{
      'd-flex align-self-center': formElement.as,
      'show-element': !formElement.as,
      'show-element-border': formElement.showBorder,
    }">
    <slot
      v-if="checkFormElementSlot(formElement) || !formElement.as"
      v-bind="componentProps"
      :name="formElement.key || `custom.${formElement.slot}`"
      :localFormData="value"
      :value="localValue"
    />

    <!-- 
      ------------------ DYNAMIC FORM ELEMENT GENERATION Functionality ------------------
      
      key [String]: v-model variable of the new form element that is being created
      as [String/Component]:  name (camelCase) of the standard form element component to create (e.g. 'textfield', 'textarea', 'searchInput')
                              more available components can be added from @/components/forms/inputs/_global
                              or from components section for on-demand load.
                              Alternatively it can be assigned an imported custom component (PascalCase) (note: must support v-model)
      object [Object]: object that can contain all the props and attributes that should be passed to the component
                       e.g. That may include standard vuetify properties such as { type: 'number', min: 0, max: 100 } for a v-textfield element
      -----------------------------------------------------------------------------------
    -->
    <component
      v-else
      v-model="localValue"
      v-bind="componentProps"
      v-on="mergedListeners"
      :class="['generated-by-form']"
      generated-by-form
      :name="formElement.key"
      :is="componentType"
      :show-data="formElement.as === 'nestedForm' ? $attrs['show-data'] || $attrs['showData'] : undefined"
      class="form-element-component"
    >
      <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>
      <template v-for="(_, slotName) in $slots" #[slotName]>
        <slot :name="slotName" />
      </template>
    </component>
    <div class="mt-4" />
  </div>
</template>

<script>
import { get, join } from 'lodash';

export default {
  props: {
    //only used for passing the whole formData object to slot
    value: {
      type: null,
      required: true,
    },
    formElement: {
      type: Object,
      default: undefined,
    },
    componentType: {
      type: [String, Object, Function],
      default: undefined
    },
  },
  data() {
    return {
    };
  },
  computed: {
    eventListeners() {
      const { input, ...listeners } = this.$listeners; // exclude `input`-listener
      return listeners;
    },
    mergedListeners() {
      return { ...this.formElement?.listeners, ...this.eventListeners };
    },
    componentProps() {
      return this.formElement?.object || {};
    },
    localValue: {
      get() {
        return this.get(this.value, this.formElement?.key);
      },
      set(v) {
        var keys = this.formElement?.key?.split('.') || [];
        if (keys.length > 1) {
          const attr = this.join(keys.splice(-1));
          this.$set(this.get(this.value, this.join(keys, '.')), attr, v);
        } else if (keys.length === 1) {
          this.$set(this.value, this.formElement.key, v);
        }
        this.$emit('input', this.value);
      }
    },
  },
  methods: {
    get,
    join,
    //check if slot is true (used for creating slot for keys), otherwise check if slot is string, in which case we create custom slot
    checkFormElementSlot(formElement) {
      return formElement.slot 
              && (formElement.slot==true || (Object.prototype.toString.call(formElement.slot) === '[String]' && formElement.slot.isEmpty()));
    },
  },
}
</script>
<style lang="scss" scoped>
.show-element {
  @include text-value;
  @include text-value-color;
  @include show-form-element-value-layout;
}
.show-element-border {
  @include show-form-element-value-border;
  @include show-form-element-value-border-color;
}
.form-element-component {
  width: 100%;
}
</style>